import React from 'react';
import { useTranslation } from 'react-i18next';
import OInput from '../../../UI/FormControls/OInput';

const Inputs = ({ formValues, setFormValues }) => {
  const { t, i18n } = useTranslation();
  const handleChange = (item) => {
    setFormValues((curr) => {
      return { ...curr, [item.target.name]: item.target.value };
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '2px',
        marginBottom: '10px',
      }}
    >
      <OInput
        label="Naziv *"
        name="naziv"
        value={formValues.naziv}
        handleChange={handleChange}
        touched={formValues.touchedNaziv}
        setTouched={() => {
          setFormValues((curr) => {
            return { ...curr, touchedNaziv: true };
          });
        }}
        errorMessage={`Naziv  ${t('isRequired')}`}
        style={{ width: '80%' }}
      />

      <OInput
        type="number"
        label="Redosled  *"
        name="redosled"
        value={formValues.redosled}
        handleChange={handleChange}
        touched={formValues.touchedRedosled}
        setTouched={() => {
          setFormValues((curr) => {
            return { ...curr, touchedRedosled: true };
          });
        }}
        errorMessage={`${t('order')} ${t('isRequired')}`}

        // style={{ width: '100%' }}
      />
    </div>
  );
};

export default Inputs;
